/* eslint-disable no-unused-vars */
export enum RESET_PASSWORD_TYPE {
    NEW_USER = "new-user",
    RESET_PASSWORD = "reset-password",
}
